import React from 'react'
import Section from '../components/Section'

function FAQs() {
	return (
		<div className='main-container'>
			<Section className='height-auto'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-sm-8 col-md-7 text-center'>
							<h2>FAQs</h2>
						</div>
					</div>
				</div>
			</Section>

			<Section id='questions__section'>
				<div className='col-md-6'>
					<ul className='questions__list'>
						<li className='questions__list-item'>
							<h4>
								What currency does The Etho use when processing
								payments?
							</h4>
							<p>
								Since we’re based in Austin, TX, all items are
								bought and sold on The Etho in US dollars ($
								USD)
							</p>
						</li>
						<li className='questions__list-item'>
							<h4>How do I see the status of my order?</h4>
							<p>
								Once your order has been submitted, you will
								start getting notifications sent to the email
								you used at checkout. These will provide you
								with shipping updates, shop information related
								to your order, and a way to contact various shop
								sellers if you have questions for them (or
								problems with your order).
							</p>
						</li>
						<li className='questions__list-item'>
							<h4>How do I sell my products on The Etho?</h4>
							<p>
								You can read more about becoming a seller&nbsp;
								<a href='/sell-with-us'>here</a>
							</p>
						</li>
					</ul>
				</div>
				<div className='col-md-6'>
					<ul className='questions__list'>
						<li className='questions__list-item'>
							<h4>
								What do I do if I need to alter or cancel my
								order?
							</h4>
							<p>
								See our{' '}
								<a href='/shipping-and-returns'>
									Shipping + Returns
								</a>{' '}
								page for this
							</p>
						</li>
						<li className='questions__list-item'>
							<h4>What is your Ethical Verification Process?</h4>
							<p>
								You can read more about our Ethical Verification
								Process <a href='/process'>here</a>
							</p>
						</li>
					</ul>
				</div>
			</Section>
		</div>
	)
}

export default FAQs
